import { StoppageStore } from '@operations/stores/StoppageStore'
import { action, computed, makeObservable, observable } from 'mobx'

export class StoppageViewUIStore {
  stoppageToBeDeletedId?: number
  isDeleteDialogOpen = false
  searchTerm?: string

  constructor(private readonly stoppageStore: StoppageStore) {
    makeObservable(this, {
      isDeleteDialogOpen: observable,
      stoppageToBeDeletedId: observable,
      searchTerm: observable,

      toggleDeleteDialog: action,
      setSearchTerm: action,

      stoppages: computed,
    })
  }

  public toggleDeleteDialog(id?: number): void {
    this.stoppageToBeDeletedId = id
    this.isDeleteDialogOpen = !this.isDeleteDialogOpen
  }

  public setSearchTerm(value: string): void {
    this.searchTerm = value
  }

  public get stoppages() {
    return this.stoppageStore.orderedItems.filter(stoppage => {
      if (!this.searchTerm) return true

      const searchTerm = this.searchTerm.toLowerCase()
      const stoppageName = stoppage.stoppageReason.name.toLowerCase()

      return stoppageName.includes(searchTerm)
    })
  }
}
